import { useState, useEffect } from 'react';
import '../css/index.css'
import '../css/qnbg-download.css'
import screenImg from './screen.png'
import appicon from './appicon1.jpg'
import { Helmet } from 'react-helmet-async';
import DownloadEntry from '../components/DownloadEntry';

/** 仅 ≥768px 视为桌面端；移动端返回 false，用于决定是否加载首屏大图 */
function useIsDesktop(): boolean {
    const [desktop, setDesktop] = useState(
        typeof window !== 'undefined' ? window.matchMedia('(min-width: 768px)').matches : true
    );
    useEffect(() => {
        const mq = window.matchMedia('(min-width: 768px)');
        const handler = () => setDesktop(mq.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);
    return desktop;
}

function Index() {
    const isDesktop = useIsDesktop();
    const newTheme = 'nopadding';
    document.body.className = newTheme;
    return (
        <div>
            <Helmet>
                <title>表格工坊</title>
                {/* <link rel="icon" href="/favicon.ico" /> */}
            </Helmet>
            <div className='gradienty-pur'>
                {isDesktop && <img className='left-image' src={screenImg} />}

                <div className='right-div'>
                    <img className='appicon' src={appicon} />
                    <p className='title'>表格工坊</p>
                    <p className='sub-title'>全平台快速表格制作</p>
                    <div className='detail'>
                        <p className='detail'>· 一键美化表格，海量主题快速出图</p>
                        <p className='detail'>· 智能极速计算，一键求和告别手算</p>
                        <p className='detail'>· 海量使用模板，即选即用制表无忧</p>
                        <p className='detail'>· 实时用户支持，1分钟让你快速上手</p>
                        <p className='detail'>···</p>
                    </div>
                </div>

                <DownloadEntry floating />
            </div>
            <div className='footer-pur'>
                <div style={{ display: 'flex' }}>
                    <a href='./yeiontable/privacyios'><p>《用户隐私协议》</p></a>
                    <a href='./yeiontable/term'><p>《使用条款》</p></a>
                </div>

                <div style={{ display: 'flex', marginTop: 12 }}>
                    <a href='https://beian.miit.gov.cn/'><p style={{ marginRight: 20, fontSize: 14 }}>粤ICP备2021177159号-2</p></a>
                    <p style={{ fontSize: 14 }}>Copyright © 2024 野离子网络科技. All rights reserved.</p>
                </div>
            </div>
        </div>
    )
}

export default Index;